// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-12d6aeca]:hover::before, .link[data-v-12d6aeca]:focus::before, .link.is-active[data-v-12d6aeca]::before {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
